import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useConfig } from "../../utils/useConfig";
import { useData } from "../../utils/useData";
import { CreateEmployeeFormValuesType } from "../../components/employees/AddUser";
import { createUser } from "../../mutations/users/createUser";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { TagReference } from "../../models";
import { getSafeSessionConfig } from "../utils/getSafeSessionConfig";

export const useCreateUser = (
    options?: {
        onSuccess?: () => void;
        onError?: (error: Error) => void;
        successMessage?: string;
    }
) => {
  const { accounts, employees, membership, employer } = useData();
  const { config } = useConfig();
  const { getToken } = useKindeAuth();

  return useMutation(
    async ({
        formValues,
        tags,
        sendInvitationEmail }: {
            formValues: CreateEmployeeFormValuesType,
            tags: TagReference[],
            sendInvitationEmail: boolean
        }) => {
        const sessionConfig = await getSafeSessionConfig(config, getToken);

        return await createUser(
            formValues, 
            employer?.data?.country.id as any, 
            employees.data?.items, 
            membership.data, 
            sessionConfig.API_URL, 
            employer.data, 
            sessionConfig.token, 
            sendInvitationEmail, 
            tags
        );
    },
    {
        onSuccess: () => {
          toast.success("User added successfully");
          employees.refetch();
          accounts.refetch();
          options?.onSuccess?.();
        },
        onError: (error: Error) => {
          console.error("useCreateUser onError:", error.message);
          options?.onError?.(error);
        }
      }
  )
}